import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/base/Seo";
import PageHero from "@/components/feature/PageHero";
import Reveal from "@/components/base/Reveal";
import FinalCta from "@/pages/home/components/FinalCta";
import Timeline from "@/pages/home/components/Timeline";
import Testimonials from "@/pages/home/components/Testimonials";
import SobreStory from "@/pages/sobre/components/SobreStory";
import SobreStats from "@/pages/sobre/components/SobreStats";
import SobrePositioning from "@/pages/sobre/components/SobrePositioning";
import SobreValues from "@/pages/sobre/components/SobreValues";

export default function Sobre() {
  return (
    <SiteLayout>
      <Seo
        title="Sobre a NXHOST | Tecnologia e Infraestrutura desde 2007"
        description="Conheça a NXHOST: desde 2007 oferecendo hospedagem, servidores e soluções digitais para empresas que precisam estar online com confiança e desempenho."
        keywords="sobre NXHOST, empresa de tecnologia, infraestrutura digital, hospedagem desde 2007"
        path="/sobre"
        titleEn="About NXHOST | Technology and Infrastructure since 2007"
        titleEs="Sobre NXHOST | Tecnología e Infraestructura desde 2007"
        descriptionEn="Get to know NXHOST: since 2007 providing hosting, servers and digital solutions for companies that need to stay online with confidence and performance."
        descriptionEs="Conoce NXHOST: desde 2007 ofreciendo hosting, servidores y soluciones digitales para empresas que necesitan estar online con confianza y rendimiento."
        breadcrumbs={[
          { name: "Início", path: "/" },
          { name: "Sobre", path: "/sobre" },
        ]}
      />
      <PageHero
        badge="Sobre a NXHOST"
        badgeIcon="ri-building-2-line"
        title="Experiência que acompanha a evolução da internet."
        subtitle="Desde 2007, a NXHOST atua no segmento de tecnologia e infraestrutura digital, acompanhando de perto a evolução das necessidades de empresas e projetos online."
        crumbs={[{ label: "Início", to: "/" }, { label: "Sobre" }]}
      >
        <Reveal delay={220}>
          <div className="rounded-2xl border border-background-50/10 bg-foreground-900/60 p-6 backdrop-blur-sm">
            <div className="grid grid-cols-2 gap-6">
              <div>
                <p className="font-heading text-3xl font-bold text-background-50">+19</p>
                <p className="mt-1 text-xs text-background-300">anos de experiência</p>
              </div>
              <div>
                <p className="font-heading text-3xl font-bold text-background-50">BR</p>
                <p className="mt-1 text-xs text-background-300">servidores no Brasil</p>
              </div>
            </div>
            <div className="mt-6 border-t border-background-50/10 pt-5">
              <p className="text-sm leading-relaxed text-background-200">
                Hospedagem, servidores e soluções digitais reunidos em uma só estrutura.
              </p>
            </div>
          </div>
        </Reveal>
      </PageHero>

      <SobreStory />
      <SobreStats />
      <SobrePositioning />
      <Timeline />
      <SobreValues />
      <Testimonials
        badge="Clientes"
        title="Relações construídas com quem confia na NXHOST."
        description="Empresas de diferentes segmentos contam com a nossa estrutura para manter os seus projetos online, com atendimento próximo e tecnologia de verdade."
      />
      <FinalCta />
    </SiteLayout>
  );
}